export default __webpack_public_path__ + "static/media/male-icon.958e241b.png";